import { useMfaServiceMfaConfigsRetrieve } from '@organization/api/queries'
import { Button, Col, Flex, Form, Input, Row } from 'antd'
import { FormProps } from 'antd/lib'
import { Add, Trash } from 'iconsax-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  dataId?: string
} & FormProps

export const ConfigMFAForm = ({ dataId, ...props }: Props) => {
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const { data } = useMfaServiceMfaConfigsRetrieve(
    { id: String(dataId) },
    [String(dataId)],
    {
      enabled: !!dataId
    }
  )

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        backup_codes: data.backup_codes || []
      })
    }
  }, [data, form])

  return (
    <Form form={form} layout="vertical" {...props}>
      <Form.List name="backup_codes">
        {(fields, { add, remove }) => (
          <Flex vertical gap={16}>
            <Row gutter={[16, 16]}>
              {fields.map(({ key, name, ...restField }) => (
                <Col span={12} key={key}>
                  <Flex gap={4} align="start">
                    <Form.Item
                      {...restField}
                      name={name}
                      style={{ marginBottom: 0, flex: 1 }}
                      rules={[
                        {
                          required: true,
                          message: t('form.message.backup_code')
                        },
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.resolve()
                            }
                            if (!/^[A-Z0-9]{8}$/.test(value.toUpperCase())) {
                              return Promise.reject(
                                new Error(
                                  t('form.message.invalid_backup_code_format', {
                                    backup_code: value.toUpperCase()
                                  })
                                )
                              )
                            }
                            return Promise.resolve()
                          }
                        }
                      ]}
                    >
                      <Input
                        placeholder={t('backup_code')}
                        maxLength={8}
                        onChange={(e) => {
                          const value = e.target.value
                            .toUpperCase()
                            .replaceAll(/[^A-Z0-9]/g, '')
                          form.setFieldValue(['backup_codes', name], value)
                        }}
                      />
                    </Form.Item>

                    <Button
                      type="text"
                      danger
                      icon={<Trash size={16} />}
                      onClick={() => remove(name)}
                    />
                  </Flex>
                </Col>
              ))}
            </Row>

            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<Add size={16} />}
              >
                {t('button.add')} {t('backup_code').toLowerCase()}
              </Button>
            </Form.Item>
          </Flex>
        )}
      </Form.List>
    </Form>
  )
}
